import Link from "next/link";
import clsx from "clsx";

import { ChevronRight } from "@chef/icons/small";

interface BreadcrumbsProps {
  breadcrumbs: { slug: string; value: string | number }[];
}

export const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsProps) => {
  const isRootPage = breadcrumbs.length === 1;

  return (
    <nav aria-label="breadcrumb">
      <ul className="flex text-sm">
        {breadcrumbs.map((crumb, i) => {
          const isLastCrumb = i === breadcrumbs.length - 1;
          const linkPath = `/${breadcrumbs
            .map((c) => c.slug.replace(/\//, ""))
            .slice(0, i + 1)
            .join("/")}`;

          return (
            <li
              key={crumb.slug}
              className={clsx("flex items-center ml-0 mr-3", {
                "cursor-default": isRootPage || isLastCrumb,
                "hover:cursor-pointer": !isRootPage && !isLastCrumb,
              })}
            >
              {isRootPage || isLastCrumb ? (
                <span>{crumb.value}</span>
              ) : (
                <Link href={linkPath}>
                  <span>{crumb.value}</span>
                </Link>
              )}
              {i < breadcrumbs.length - 1 && <ChevronRight className="ml-3" />}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
